import { render } from "./mvt-markettrendscta.vue?vue&type=template&id=70fe9fec"
import script from "./mvt-markettrendscta.js?vue&type=script&lang=js"
export * from "./mvt-markettrendscta.js?vue&type=script&lang=js"

import "./mvt-markettrendscta.vue?vue&type=style&index=0&id=70fe9fec&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__